/**
 * Created by mac on 2/3/21
 */

const UnitSaver = function (slotId) {
    this.slotId = slotId;

    this.prefix = `${cleverapps.config.name + connector.platform.getLocalStoragePrefix()}_map`;
    if (this.slotId) {
        this.prefix += `_${this.slotId}_`;
    }

    this.mapSize = cc.size(UnitSaver.BIGGEST_MAP_WIDTH, UnitSaver.BIGGEST_MAP_HEIGHT);

    this.listSlotLocations().forEach((locationId) => {
        const bundle = bundles[cleverapps.meta.getLocationMeta(locationId).locationConfig.locationBundleId];
        this.mapSize = cc.size(
            Math.max(this.mapSize.width, bundle.meta.mapSize.width),
            Math.max(this.mapSize.height, bundle.meta.mapSize.height)
        );
    });

    this.migrateSlotDragonia();
};

UnitSaver.BIGGEST_MAP_WIDTH = 100;
UnitSaver.BIGGEST_MAP_HEIGHT = 100;

UnitSaver.prototype.listSlotLocations = function () {
    return Object.values(bundles).filter((bundle) => bundle.meta.location).map((bundle) => bundle.meta.location).filter((locationId) => {
        const locationMetaConfig = cleverapps.meta.getLocationMeta(locationId).locationConfig;
        const bundle = bundles[locationMetaConfig.locationBundleId];
        return this.slotId === locationMetaConfig.slotId && bundle && bundle.meta.mapSize;
    });
};

UnitSaver.prototype.loadData = function (key) {
    let data = cleverapps.dataLoader.load(key, { raw: true });
    if (!data) {
        return;
    }

    data = data.charAt(0) !== "{" ? UnitPacker.expandUnit(data) : JSON.parse(data);

    if (data.code && typeof data.code !== "string") {
        if (Array.isArray(data.code) && data.code.length === 1) {
            data.code = data.code[0];
        }
    }

    if (data._compact) {
        data = UnitPacker.expandUnit(data._compact, data.code);
        delete data.x;
        delete data.y;
    }

    return data;
};

UnitSaver.prototype.reset = function () {
    for (let x = 0; x < this.mapSize.width; x++) {
        for (let y = 0; y < this.mapSize.height; y++) {
            this.remove(x, y);
        }
    }

    this.resetKickOuts();
};

UnitSaver.prototype.save = function (x, y, data) {
    if (Unit.DELETED_CODES[data.code]) {
        return;
    }

    const key = this.getStoreKey(x, y);
    const dataStr = JSON.stringify(data);
    cleverapps.dataLoader.save(key, dataStr, { raw: true });
};

UnitSaver.prototype.getStoreKey = function (x, y) {
    return `${this.prefix + x}_${y}`;
};

UnitSaver.prototype.remove = function (x, y) {
    cleverapps.dataLoader.remove(this.getStoreKey(x, y));
};

UnitSaver.prototype.migrateSlotDragonia = function () {
    if (this.slotId !== "2") {
        return;
    }

    let x, y, dataStr, key, oldKey;

    for (x = 10; x < this.mapSize.width; x++) {
        for (y = 0; y < this.mapSize.height; y++) {
            key = this.getStoreKey(x, y);
            oldKey = key.replace("_map_2_", "_map2");

            dataStr = cleverapps.dataLoader.load(oldKey, { raw: true });
            if (dataStr) {
                cleverapps.dataLoader.save(key, dataStr, { raw: true });
                cleverapps.dataLoader.remove(oldKey);
            }
        }
    }
};

UnitSaver.prototype.loadAll = function () {
    const units = [];

    for (let x = 0; x < this.mapSize.width; x++) {
        for (let y = 0; y < this.mapSize.height; y++) {
            const key = this.getStoreKey(x, y);
            const data = this.loadData(key);
            if (!data || Unit.DELETED_CODES[data.code] || Unit.DISABLED_CODES[data.code]) {
                continue;
            }

            units.push({ x, y, data });
        }
    }

    units.sort(UnitSaver.UNITS_IMPORTANCE_ORDER);

    const index = {};

    units.forEach(({ x, y, data }) => {
        const key = `${x}_${y}`;
        if (index[key]) {
            cleverapps.throwAsync(`UnitsSyncer.init collision at ${key}: ${index[key]} and ${data.code}`);
            return;
        }
        index[key] = data.code;
    });

    return units;
};

UnitSaver.prototype.updateInfo = function (units) {
    for (let x = 0; x < this.mapSize.width; x++) {
        for (let y = 0; y < this.mapSize.height; y++) {
            const key = this.getStoreKey(x, y);
            if (this.loadData(key)) {
                cleverapps.dataLoader.remove(key);
            }
        }
    }

    const index = {};
    const kickOuts = [];
    units.sort(UnitSaver.UNITS_IMPORTANCE_ORDER).forEach((unit) => {
        const key = `${unit.x}_${unit.y}`;
        if (!index[key] || index[key] === "intact") {
            index[key] = unit.data.code;
            this.save(unit.x, unit.y, unit.data);
        } else if (unit.data.code !== "intact") {
            kickOuts.push(unit);

            cleverapps.throwAsync(`UnitsSyncer.updateInfo kickout at ${this.slotId} ${key}: ${unit.data.code} ${unit.data.stage} replaced by ${index[key]}`);
        }
    });

    this.saveKickOuts(kickOuts);
};

UnitSaver.prototype.loadKickOuts = function (knownFamilies) {
    const units = cleverapps.dataLoader.load(DataLoader.TYPES.UNIT_SAVER_KICKOUTS + this.slotId) || [];

    units.forEach((unit) => {
        unit.data = Families.processUnknown(unit.data, knownFamilies);
    });

    return units;
};

UnitSaver.prototype.saveKickOuts = function (kickOuts) {
    cleverapps.dataLoader.save(DataLoader.TYPES.UNIT_SAVER_KICKOUTS + this.slotId, kickOuts);
};

UnitSaver.prototype.resetKickOuts = function () {
    cleverapps.dataLoader.remove(DataLoader.TYPES.UNIT_SAVER_KICKOUTS + this.slotId);
};

UnitSaver.UNITS_IMPORTANCE_ORDER = function (unit1, unit2) {
    const data1 = Families[unit1.data.code] && Families[unit1.data.code].units[unit1.data.stage] || {};
    const data2 = Families[unit2.data.code] && Families[unit2.data.code].units[unit2.data.stage] || {};

    if ((data1.type === "hero" || data2.type === "hero") && data1.customer !== data2.customer) {
        return data1.customer ? -1 : 1;
    }

    if (data1.important !== data2.important) {
        return data1.important ? -1 : 1;
    }

    return unit2.data.stage - unit1.data.stage;
};
